import { useLocalStorageState } from '../../hooks/useLocalStorage';

const COFFEE_WHITE_PAGES_KEY = 'coffee-white-pages';

/**
 * Light pages default to a white card on the Coffee blue; this switches them to a full-white page instead.
 * Client-only and internal: clearing storage silently reverts to the card.
 */
export function useCoffeeWhitePages(): [boolean, (next: boolean) => void] {
	return useLocalStorageState<boolean>(COFFEE_WHITE_PAGES_KEY, false);
}

/** Gates discovery only. Set in the non-production env files, never `.env.production`. */
export const isCoffeeWhitePagesToggleVisible = () => import.meta.env.VITE_COFFEE_WHITE_PAGES_TOGGLE === 'true';
